import { Theme, useMediaQuery } from '@mui/material';

export const useResponsive = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return { isMobile };
};